import React, { useState, useRef } from "react";
import {
  Box,
  Container,
  Typography,
  Card,
  CardContent,
  TextField,
  Button,
  Grid2,
  IconButton,
  FormControlLabel,
  Checkbox
} from "@mui/material";
import {
  GoogleMap,
  LoadScript,
  Marker,
  Autocomplete,
  DirectionsService,
  DirectionsRenderer,
} from "@react-google-maps/api";

import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { DatePicker } from "@mui/x-date-pickers";

const libraries = ["places"];
const defaultOrigin = {
  lat: 20.6080683,
  lng: -103.3998273,
}; // Españoles 91, La Duraznera, Guadalajara

export default function LogisticaGruas() {
  const [chofer, setChofer] = useState("");
  const [vehiculo, setVehiculo] = useState("");
  const [stops, setStops] = useState([]);
  const [directions, setDirections] = useState(null);
  const [totalKm, setTotalKm] = useState(null);
  const autocompleteRef = useRef(null);
  const [inputValue, setInputValue] = useState("");

  // Itinerario
  const [mostrarDia, setMostrarDia] = useState(true);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedDate2, setSelectedDate2] = useState(new Date());
  const [daysList, setDaysList] = useState([]);
  const [mostrarDaysList, setMostrarDaysList] = useState(false);

  const generateDays = () => {
    const start = new Date(selectedDate);
    const end = new Date(selectedDate2);
    const days = [];
    while (start <= end) {
      days.push({ date: new Date(start), salida: "", llegada: "" });
      start.setDate(start.getDate() + 1);
    }
    setDaysList(days);
    setMostrarDaysList(true);
  };

  const handleHourChange = (index, field, value) => {
    setDaysList((prev) => {
      const updated = [...prev];
      updated[index][field] = value;
      return updated;
    });
  };

  const handlePlaceSelected = () => {
    const place = autocompleteRef.current.getPlace();
    if (!place.geometry) return;
  
    const newStop = {
      direccion: place.formatted_address,
      lat: place.geometry.location.lat(),
      lng: place.geometry.location.lng(),
      pedido: "",
      modelo: "",
    };
  
    setStops((prev) => [...prev, newStop]);
    setInputValue(""); // 🔄 limpia el input
  };

  const updateStop = (index, field, value) => {
    const updated = [...stops];
    updated[index][field] = value;
    setStops(updated);
  };

  const handleSubmit = () => {
    // Formatear daysList para exportación limpia
    const formattedDaysList = daysList.map((day) => ({
        date: day.date.toISOString().split("T")[0],
        salida: day.salida || "00:01",
        llegada: day.llegada || "23:59",
    }));
    const viaje = {
        chofer,
        vehiculo,
        origen: defaultOrigin,
        paradas: stops,
        daysList: formattedDaysList,
    }
    if (stops.length === 0) return;

    const waypoints = stops.slice(0, -1).map((stop) => ({
      location: { lat: stop.lat, lng: stop.lng },
      stopover: true,
    }));

    const serviceOptions = {
      origin: defaultOrigin,
      destination: {
        lat: stops[stops.length - 1].lat,
        lng: stops[stops.length - 1].lng,
      },
      travelMode: "DRIVING",
      waypoints: waypoints,
      optimizeWaypoints: true,
    };

    const directionsService = new window.google.maps.DirectionsService();
    directionsService.route(serviceOptions, (result, status) => {
      if (status === "OK") {
        setDirections(result);

        const totalMeters = result.routes[0].legs.reduce(
          (acc, leg) => acc + leg.distance.value,
          0
        );
        setTotalKm((totalMeters / 1000).toFixed(2));
      } else {
        console.error("Error en la ruta:", status);
      }
    });

    console.log(JSON.stringify(viaje, null, 2));
  };

  return (
    <LoadScript googleMapsApiKey="AIzaSyDHkpz3qbH2j6KuFgytJdSNEJp3Pp7XaL0" libraries={libraries}>
      <Container maxWidth="md" sx={{ mt: 4 }}>
        <Typography variant="h4" gutterBottom>
          Ruta de Entrega - Logística
        </Typography>

        <Card sx={{ mb: 2 }}>
          <CardContent>
            <Grid2 container spacing={2}>
              <Grid2 item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Chofer"
                  value={chofer}
                  onChange={(e) => setChofer(e.target.value)}
                />
              </Grid2>
              <Grid2 item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Vehículo (grúa)"
                  value={vehiculo}
                  onChange={(e) => setVehiculo(e.target.value)}
                />
              </Grid2>
              <Grid2 item xs={12}>
                <Autocomplete
                    onLoad={(ref) => (autocompleteRef.current = ref)}
                    onPlaceChanged={handlePlaceSelected}
                    inputValue={inputValue}
                    onInputChange={(_, value) => setInputValue(value)}
                >
                    <TextField
                        fullWidth
                        label="Agregar nueva parada"
                        placeholder="Buscar dirección..."
                    />
                </Autocomplete>
              </Grid2>
            </Grid2>
          </CardContent>
        </Card>

        {stops.map((stop, index) => (
          <Card key={index} sx={{ mb: 2 }}>
            <CardContent>
              <Typography variant="subtitle1" gutterBottom>
                Parada #{index + 1}
              </Typography>
              <Typography variant="body2" gutterBottom>
                Dirección: {stop.direccion}
              </Typography>
              <Grid2 container spacing={2}>
                <Grid2 item xs={12} sm={6}>
                  <TextField
                    label="Número de Pedido"
                    value={stop.pedido}
                    onChange={(e) => updateStop(index, "pedido", e.target.value)}
                    fullWidth
                  />
                </Grid2>
                <Grid2 item xs={12} sm={6}>
                  <TextField
                    label="Modelo de Máquina"
                    value={stop.modelo}
                    onChange={(e) => updateStop(index, "modelo", e.target.value)}
                    fullWidth
                  />
                </Grid2>
              </Grid2>
            </CardContent>
          </Card>
        ))}

        <Box mt={4}>
          {mostrarDia && (
            <>
              {/* Calendarios */}
              <Box display="flex" gap={2} mt={2}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    label="Fecha inicio"
                    value={selectedDate}
                    onChange={(newVal) => setSelectedDate(newVal)}
                    renderInput={(params) => <TextField {...params} fullWidth />}
                  />
                  <DatePicker
                    label="Fecha fin"
                    value={selectedDate2}
                    onChange={(newVal) => setSelectedDate2(newVal)}
                    renderInput={(params) => <TextField {...params} fullWidth />}
                  />
                </LocalizationProvider>
                <Button variant="outlined" onClick={generateDays}>Generar Itinerario</Button>
              </Box>

              {mostrarDaysList && (
                <Box mt={2}>
                    {daysList.map((day, i) => (
                    <Card key={i} sx={{ my: 1, p: 2, display: "flex", alignItems: "center", gap: 2 }}>
                        <AccessTimeIcon />
                        <Typography sx={{ flexGrow: 1 }}>
                        {day.date.toLocaleDateString("es-ES", {
                            weekday: "long",
                            day: "numeric",
                            month: "short"
                        })}
                        </Typography>

                        {i === 0 && (
                        <TextField
                            type="time"
                            value={day.salida}
                            onChange={(e) => handleHourChange(i, "salida", e.target.value)}
                        />
                        )}

                        {i === daysList.length - 1 && (
                        <TextField
                            type="time"
                            value={day.llegada}
                            onChange={(e) => handleHourChange(i, "llegada", e.target.value)}
                        />
                        )}
                    </Card>
                    ))}
                </Box>
              )}
            </>
          )}
        </Box>

        <Button variant="contained" fullWidth onClick={handleSubmit} sx={{ mt: 3 }}>
          Guardar Ruta y Calcular Distancia
        </Button>

        {totalKm && (
          <Box mt={2}>
            <Typography variant="h6">Kilómetros Totales: {totalKm} km</Typography>
          </Box>
        )}

        <Box mt={4} sx={{ height: "400px" }}>
          <GoogleMap
            mapContainerStyle={{ width: "100%", height: "100%" }}
            center={defaultOrigin}
            zoom={12}
          >
            <Marker position={defaultOrigin} />
            {stops.map((stop, i) => (
              <Marker
                key={i}
                position={{ lat: stop.lat, lng: stop.lng }}
              />
            ))}
            {directions && <DirectionsRenderer directions={directions} />}
          </GoogleMap>
        </Box>
      </Container>
    </LoadScript>
  );
}
